var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temFontes
    ? _c(
        "div",
        { staticClass: "chat-message-fontes" },
        [
          _c(
            "span",
            { staticClass: "chat-message-fontes__label ia-texto-selo" },
            [_vm._v("Fontes")]
          ),
          _c(
            "v-menu",
            {
              attrs: {
                "open-on-hover": "",
                "offset-y": "",
                "close-on-content-click": false,
                "close-delay": _vm.ATRASO_PARA_FECHAR,
                top: "",
                "nudge-top": _vm.FOLGA_ACIMA_DO_CHIP,
                "content-class": "ia-fontes-menu",
                "min-width": "260",
                "max-width": "340"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "button",
                          _vm._g(
                            _vm._b(
                              {
                                staticClass:
                                  "chat-message-fontes__chip ia-texto-auxiliar",
                                attrs: {
                                  type: "button",
                                  "aria-label": _vm.rotuloDoGatilho
                                },
                                on: {
                                  click: function($event) {
                                    _vm.aberto = !_vm.aberto
                                  }
                                }
                              },
                              "button",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "chat-message-fontes__avatar ia-texto-micro",
                                attrs: { "aria-hidden": "true" }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.principal.inicial) + " "
                                )
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "chat-message-fontes__nome" },
                              [_vm._v(_vm._s(_vm.principal.rotulo))]
                            ),
                            _c(
                              "span",
                              { staticClass: "chat-message-fontes__count" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.principal.registrosFormatados) +
                                    " "
                                )
                              ]
                            ),
                            _vm.demais
                              ? _c(
                                  "span",
                                  { staticClass: "chat-message-fontes__mais" },
                                  [_vm._v(" +" + _vm._s(_vm.demais) + " ")]
                                )
                              : _vm._e()
                          ]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                4191678295
              ),
              model: {
                value: _vm.aberto,
                callback: function($$v) {
                  _vm.aberto = $$v
                },
                expression: "aberto"
              }
            },
            [
              _c("div", { staticClass: "chat-message-fontes__painel" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "chat-message-fontes__painel-topo ia-texto-selo"
                  },
                  [_vm._v("Fontes")]
                ),
                _c(
                  "ul",
                  { staticClass: "chat-message-fontes__lista" },
                  _vm._l(_vm.fontes, function(fonte) {
                    return _c(
                      "li",
                      {
                        key: fonte.tabela,
                        staticClass: "chat-message-fontes__item"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "chat-message-fontes__avatar ia-texto-micro",
                            attrs: { "aria-hidden": "true" }
                          },
                          [_vm._v(" " + _vm._s(fonte.inicial) + " ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "chat-message-fontes__item-nome",
                            attrs: { title: fonte.tabela }
                          },
                          [_vm._v(" " + _vm._s(fonte.rotulo) + " ")]
                        ),
                        _c(
                          "span",
                          { staticClass: "chat-message-fontes__item-count" },
                          [
                            _vm._v(
                              " " + _vm._s(fonte.registrosFormatados) + " "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }